namespace Nobox.NoBoxCRM {
    export interface FormresultsForm {
        SenderNm: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
        FormId: Serenity.ServiceLookupEditor;
        St: FormStatusEditor;
        IsPaid: FormStatusPaymentEditor;
        DateIn: CustomDateTimeEditor;
        TagIds: Serenity.ServiceLookupEditor;
        Products: FormResultProductsEditor;
        Data: Serenity.Extensions.StaticTextBlock;
        Order: Serenity.Extensions.StaticTextBlock;
        Additional: Serenity.StringEditor;
        AdditionalPrice: AutoNumericEditor;
        Reduction: Serenity.StringEditor;
        ReductionPrice: AutoNumericEditor;
        GrandTotal: AutoNumericEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class FormresultsForm extends Serenity.PrefixedContext {
        static formKey = 'NoBoxCRM.Formresults';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FormresultsForm.init)  {
                FormresultsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ServiceLookupEditor;
                var w2 = FormStatusEditor;
                var w3 = FormStatusPaymentEditor;
                var w4 = CustomDateTimeEditor;
                var w5 = FormResultProductsEditor;
                var w6 = s.Extensions.StaticTextBlock;
                var w7 = AutoNumericEditor;

                Q.initFormType(FormresultsForm, [
                    'SenderNm', w0,
                    'Phone', w0,
                    'FormId', w1,
                    'St', w2,
                    'IsPaid', w3,
                    'DateIn', w4,
                    'TagIds', w1,
                    'Products', w5,
                    'Data', w6,
                    'Order', w6,
                    'Additional', w0,
                    'AdditionalPrice', w7,
                    'Reduction', w0,
                    'ReductionPrice', w7,
                    'GrandTotal', w7,
                    'In', w4,
                    'Up', w4,
                    'InBy', w1,
                    'UpBy', w1
                ]);
            }
        }
    }
}
